import { render } from "./SalaryTemplateModal.vue?vue&type=template&id=275d154c"
import script from "./SalaryTemplateModal.vue?vue&type=script&lang=js"
export * from "./SalaryTemplateModal.vue?vue&type=script&lang=js"

import exportComponent from "/var/jenkins_home/workspace/prod-fe-app-myqampus/node_modules/vue-cli-plugin-vue-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__